# Patch one requisition. Omitted fields are unchanged; explicit null clears.
# Lifecycle state is not patched here except CLOSED via Close hiring request.
fragment UpdatedRequisitionFields on Requisition {
  id
  externalId
  state
  role
  fte
  targetStartDate
  justification
  extraAttributes
  hiringManager {
    aggregateId
    firstName
    surname
    preferredName
  }
}

fragment UpdatedRequisitionGuardrailFields on Requisition {
  guardrailDecision
  guardrailEvaluation {
    evaluatedAt
    trigger
    decision
    ruleSetContentHash
    template
    steps {
      order
      kind
      ruleId
      status
      reason
      groups {
        approverGroupId
        approverGroupName
        status
        elapsedHours
        clockStartedAt
        slaHours
        pastSla
        canRespond
        canUndo
        resolver
        assigneePersonId
        assigneePersonName
        reasons {
          id
          label
        }
        comment
      }
    }
    checks {
      ruleId
      name
      effect
      state
      detail
    }
  }
}

mutation updateRequisition($input: UpdateRequisitionInput!) {
  result: updateRequisition(input: $input) {
    ...UpdatedRequisitionFields
  }
}

# Guardrail evidence is not on every API yet, and "Cannot query field" is a
# validation error no @include can duck, so asking for it would fail the whole
# save against an API that does not serve it. Only used once the modal has
# read enableWorkforceGuardrails — see the plain mutation above.
mutation updateRequisitionWithGuardrails($input: UpdateRequisitionInput!) {
  result: updateRequisition(input: $input) {
    ...UpdatedRequisitionFields
    ...UpdatedRequisitionGuardrailFields
  }
}
